import { BN } from "@polkadot/util";
export const defaultOptions = {
    checkForDuplicateValidators: false,
    checkRootVerified: false,
    checkValidators: false,
    era: 0,
    minNumberOfValidators: 1,
    rootMinStake: new BN(0),
    numberOfPools: 1,
};
